export default __webpack_public_path__ + "static/media/anandpic.d2a4108c.jpeg";